import { useState } from 'react';

import { InspectArtifactModal } from '@/components/artifact-inspector/InspectArtifactModal';
import { ArtifactIcon } from '@/components/artifacts/components/ArtifactIcon';
import { cn } from '@/lib/utils';
import { useListArtifactsQuery } from '@/services/api/artifactService';

export const MiniTortAttachments = ({ matterId, className }: { matterId: string; className?: string }) => {
  const [inspectId, setInspectId] = useState<string | null>(null);
  const { data: artifacts } = useListArtifactsQuery({ matterId });

  if (!artifacts?.length) return null;

  return (
    <div className={cn('rounded-lg border border-zinc-200 bg-white overflow-hidden', className)}>
      <div className="px-6 py-4">
        <span className="text-[10px] font-semibold uppercase tracking-wider text-zinc-500 block mb-2.5">Documents</span>
        <div className="flex flex-wrap gap-2">
          {artifacts.map((a) => (
            <button key={a.id} type="button" onClick={() => setInspectId(a.id)}
              className="inline-flex items-center gap-1.5 rounded-md border border-zinc-200 bg-zinc-50 px-2.5 py-1.5 text-xs font-medium text-zinc-700 hover:bg-zinc-100 hover:border-zinc-300 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50">
              <ArtifactIcon type={a.artifact_type} className="h-3.5 w-3.5 text-zinc-400 shrink-0" />
              <span>{a.blob?.name || a.artifact_digest?.title || a.artifact_digest?.one_line_summary || 'Untitled'}</span>
            </button>
          ))}
        </div>
      </div>
      {inspectId && (
        <InspectArtifactModal artifactId={inspectId} isOpen onOpenChange={(o) => { if (!o) setInspectId(null); }} matterId={matterId} />
      )}
    </div>
  );
};
